export const provinceList = [
  {
    value: 'Ilocos Sur',
    label: 'Ilocos Sur',
  },
  {
    value: 'La Union',
    label: 'La Union',
  },
  {
    value: 'Abra',
    label: 'Abra',
  },
  {
    value: 'Benguet',
    label: 'Benguet',
  },
  {
    value: 'Ilocos Norte',
    label: 'Ilocos Norte',
  },
  {
    value: 'Pangasinan',
    label: 'Pangasinan',
  },
  {
    value: 'Mountain Province',
    label: 'Mountain Province',
  },
  {
    value: 'Manila',
    label: 'Manila',
  },
  {
    value: 'Nueva Vizcaya',
    label: 'Nueva Vizcaya',
  },
  {
    value: 'Batanes',
    label: 'Batanes',
  },
  {
    value: 'Cagayan',
    label: 'Cagayan',
  },
  {
    value: 'Isabela',
    label: 'Isabela',
  },
  {
    value: 'Kalinga',
    label: 'Kalinga',
  },
  {
    value: 'Quirino',
    label: 'Quirino',
  },
  {
    value: 'Apayao',
    label: 'Apayao',
  },
  {
    value: 'Ifugao',
    label: 'Ifugao',
  },
  {
    value: 'Quirino',
    label: 'Quirino',
  },
  {
    value: 'Aurora',
    label: 'Aurora',
  },
  {
    value: 'Bataan',
    label: 'Bataan',
  },
  {
    value: 'Bulacan',
    label: 'Bulacan',
  },
  {
    value: 'Nueva Ecija',
    label: 'Nueva Ecija',
  },
  {
    value: 'Pampanga',
    label: 'Pampanga',
  },
  {
    value: 'Tarlac',
    label: 'Tarlac',
  },
  {
    value: 'Zambales',
    label: 'Zambales',
  },
  {
    value: 'Batangas',
    label: 'Batangas',
  },
  {
    value: 'Cavite',
    label: 'Cavite',
  },
  {
    value: 'Laguna',
    label: 'Laguna',
  },
  {
    value: 'Marinduque',
    label: 'Marinduque',
  },
  {
    value: 'Occidental Mindoro',
    label: 'Occidental Mindoro',
  },
  {
    value: 'Oriental Mindoro',
    label: 'Oriental Mindoro',
  },
  {
    value: 'Palawan',
    label: 'Palawan',
  },
  {
    value: 'Quezon',
    label: 'Quezon',
  },
  {
    value: 'Rizal',
    label: 'Rizal',
  },
  {
    value: 'Romblon',
    label: 'Romblon',
  },
  {
    value: 'Albay',
    label: 'Albay',
  },
  {
    value: 'Camarines Norte',
    label: 'Camarines Norte',
  },
  {
    value: 'Camarines Sur',
    label: 'Camarines Sur',
  },
  {
    value: 'Catanduanes',
    label: 'Catanduanes',
  },
  {
    value: 'Masbate',
    label: 'Masbate',
  },
  {
    value: 'Sorsogon',
    label: 'Sorsogon',
  },
  {
    value: 'Aklan',
    label: 'Aklan',
  },
  {
    value: 'Antique',
    label: 'Antique',
  },
  {
    value: 'Capiz',
    label: 'Capiz',
  },
  {
    value: 'Iloilo',
    label: 'Iloilo',
  },
  {
    value: 'Negros Occidental',
    label: 'Negros Occidental',
  },
  {
    value: 'Guimaras',
    label: 'Guimaras',
  },
  {
    value: 'Bohol',
    label: 'Bohol',
  },
  {
    value: 'Cebu',
    label: 'Cebu',
  },
  {
    value: 'Negros Oriental',
    label: 'Negros Oriental',
  },
  {
    value: 'Siquijor',
    label: 'Siquijor',
  },
  {
    value: 'Western Samar',
    label: 'Western Samar',
  },
  {
    value: 'Biliran',
    label: 'Biliran',
  },
  {
    value: 'Eastern Samar',
    label: 'Eastern Samar',
  },
  {
    value: 'Leyte',
    label: 'Leyte',
  },
  {
    value: 'Northern Samar',
    label: 'Northern Samar',
  },
  {
    value: 'Southern Leyte',
    label: 'Southern Leyte',
  },
  {
    value: 'Sulu',
    label: 'Sulu',
  },
  {
    value: 'Zamboanga del Norte',
    label: 'Zamboanga del Norte',
  },
  {
    value: 'Zamboanga del Sur',
    label: 'Zamboanga del Sur',
  },
  {
    value: 'Zamboanga Sibugay',
    label: 'Zamboanga Sibugay',
  },
  {
    value: 'Basilan',
    label: 'Basilan',
  },
  {
    value: 'Tawi-tawi',
    label: 'Tawi-tawi',
  },
  {
    value: 'Dinagat Islands',
    label: 'Dinagat Islands',
  },
  {
    value: 'Agusan del Norte',
    label: 'Agusan del Norte',
  },
  {
    value: 'Agusan del Sur',
    label: 'Agusan del Sur',
  },
  {
    value: 'Bukidnon',
    label: 'Bukidnon',
  },
  {
    value: 'Camiguin',
    label: 'Camiguin',
  },
  {
    value: 'Misamis Occidental',
    label: 'Misamis Occidental',
  },
  {
    value: 'Misamis Oriental',
    label: 'Misamis Oriental',
  },
  {
    value: 'Surigao del Norte',
    label: 'Surigao del Norte',
  },
  {
    value: 'Davao De Oro',
    label: 'Davao De Oro',
  },
  {
    value: 'Davao Occidental',
    label: 'Davao Occidental',
  },
  {
    value: 'Davao del Norte',
    label: 'Davao del Norte',
  },
  {
    value: 'Davao del Sur',
    label: 'Davao del Sur',
  },
  {
    value: 'Davao Oriental',
    label: 'Davao Oriental',
  },
  {
    value: 'Sarangani',
    label: 'Sarangani',
  },
  {
    value: 'South Cotabato',
    label: 'South Cotabato',
  },
  {
    value: 'Surigao del Sur',
    label: 'Surigao del Sur',
  },
  {
    value: 'North Cotabato',
    label: 'North Cotabato',
  },
  {
    value: 'Lanao del Norte',
    label: 'Lanao del Norte',
  },
  {
    value: 'Lanao del Sur',
    label: 'Lanao del Sur',
  },
  {
    value: 'Maguindanao',
    label: 'Maguindanao',
  },
  {
    value: 'Sultan Kudarat',
    label: 'Sultan Kudarat',
  },
]
